import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDboEtvsj2OZgMS9bbu8fdlF8IDdjb9I4k",
  authDomain: "ibiraco-app.firebaseapp.com",
  projectId: "ibiraco-app",
  storageBucket: "ibiraco-app.firebasestorage.app", 
  messagingSenderId: "493681034976",
  appId: "1:493681034976:web:435914c6acd1800dce7285"
};

// Inicializa o app
const app = initializeApp(firebaseConfig);

// Na Web, o Firebase Auth já sabe usar o LocalStorage automaticamente
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;